import { render } from "./CustomCategoryShareWithOtherEvents.vue?vue&type=template&id=38465bfb&scoped=true&ts=true"
import script from "./CustomCategoryShareWithOtherEvents.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryShareWithOtherEvents.vue?vue&type=script&lang=ts"

import "./CustomCategoryShareWithOtherEvents.vue?vue&type=style&index=0&id=38465bfb&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38465bfb"]])

export default __exports__